import React from "react";
import { Page } from "@sscs/ui";
import styles from "./helpPage.module.scss";

const HelpPage = (): React.JSX.Element => (
  <Page.Root>
    <Page.Body className={styles.body}>
      <article className={styles.article}>
        <h1>You do not belong to any group</h1>
        <p>Please contact organization administrator</p>
      </article>
    </Page.Body>
  </Page.Root>
);

export default HelpPage;
